// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class StoredTextToSend {
  text: string;
  isQuickSend: boolean;
}
